<template>
  <b-container>
    <b-row no-gutters class="header__items--justify">
      <div class="header__item">
        <logo/>
        <QDivider class="header__divider" />
        <contact class="d-none d-lg-flex"></contact>
      </div>
      <div class="header__item">
        <QDivider class="header__divider" />
        <how-it-works/>
      </div>
    </b-row>
  </b-container>
</template>

<style lang="scss" scoped>
  @import "@quero/zilla-core/src/utils/variables.scss";

  .header__items--justify {
    @media (max-width: $screen-lg-min) {
      justify-content: space-between;
    }
  }

  .header {
     height: $space-j;

    @media (min-width: $screen-lg-min) {
      height: $space-j;
    }
  }

  .header__item {
    display: flex;
    height: $space-j;

    @media (min-width: $screen-lg-min) {
      height: $space-j;
    }
  }

  .header__divider {
    display: none;
    margin: $space-m $space-m;

    @media (min-width: $screen-md-min) {
      display: block;
    }
  }

  .header__item--text {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 0px;
    margin-left: $space-s
  }

  .header__item-link--icon {
    background-color: var(--color-brand-primary-pure);
    height: 20px;
    margin-left: $space-s;
    width: 20px;
  }
</style>

<script>
  import HowItWorks from '~/components/header/how-it-works';
  import Contact from '~/components/header/contact';
  import Logo from '~/components/header/logo';
  import QDivider from '~/components/q-divider';
  import { ZLink } from '@quero/zilla-vue';
  import loginProfileIcon from '~/assets/images/icons/i-profile.svg';

  export default {
    data() {
      return {
        icons: {
          loginProfileIcon,
        },
      }
    },
    components: {
      HowItWorks,
      Contact,
      Logo,
      QDivider,
      ZLink,
    }
  }
</script>
